import React, { useEffect } from 'react';
import { Col, Row, Spacer, View } from '@amzn/stencil-react-components/layout';
import { useDispatch, useSelector } from 'react-redux';
import {
  clearCampaignForm,
  createCampaign,
  updateCampaignFormStep,
  updateFormSubmissionStatus,
} from '../actions/createScheduleAction';
import {
  CampaignFormSection,
  CAMPAIGN_FORM,
  FORM_NAV_ELEMENTS,
  Message,
} from '../enums/schedulingConstant';
import { Status, StatusIndicator } from '@amzn/stencil-react-components/status-indicator';
// import { LeftNavList, LeftNavItem } from '@amzn/stencil-react-components/left-nav';
import { SideNavItem } from '@amzn/stencil-react-components/side-nav';
import { getAllMessageTemplates, getAllSegments } from '../actions/nudgeActions';
import { useState } from 'react';
import ButtonWithLoader from '../components/atoms/ButtonWithLoader';
import { ResponseStatus } from '../enums/responseStatus';
import { MessageBanner } from '@amzn/stencil-react-components/message-banner';
import { FormattedMessage } from 'react-intl';
import { CampaignSection } from '../components/campaign/CampaignSection';
import { TemplateSection } from '../components/campaign/TemplateSection';
import { ScheduleSection } from '../components/campaign/ScheduleSection';
import { ReviewAndLaunch } from '../components/campaign/ReviewAndLaunch';
import useCampaignFormData from '../hooks/useCampaignFormData';
import cloneDeep from 'lodash/cloneDeep';
import { Button } from '@amzn/stencil-react-components/button';
import { useHistory } from 'react-router-dom';
import { CAMPAIGN_LIST_PAGE, HOME_PAGE } from '../constants/routesConstant';
import CreateSegment from '../components/CreateSegment';
import { SegmentType } from '../constants/createSegment';

const SchedulingContainer = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const schedulingData = useSelector(store => store.campaign.create);
  const apiStatus = schedulingData?.status;
  const userInfo = useSelector(store => store.userInfo);
  const sessionToken = userInfo?.idToken;
  const campaignFormState = useSelector(store => store.campaign.campaignFormState);
  const schedulingDetail = useSelector(store => store.campaign.campaignFormState.segmentDetails);

  let sectionLinks;
  useEffect(() => {
    (async () => {
      await dispatch(getAllSegments(userInfo.selectedAccessGroupName, sessionToken));
      await dispatch(getAllMessageTemplates(userInfo.selectedAccessGroupName, sessionToken));
      await dispatch(updateCampaignFormStep(CampaignFormSection.CAMPAIGN));
    })();
    sectionLinks = document.querySelectorAll(FORM_NAV_ELEMENTS);
    Array.from(sectionLinks).forEach((el, index) => {
      if (index !== 0) {
        el.classList.add('disabled');
      }
    });
  }, []);

  const [isLoading, setIsLoading] = useState(false);
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const [campaignSteps, setCampaignSteps] = useState(CAMPAIGN_FORM);
  const [formState, setFormState] = useState(CampaignFormSection.CAMPAIGN);
  const [activeFormStep, setActiveFormStep] = useState(campaignSteps[0]);
  const { isFormSectionValid } = useCampaignFormData(activeFormStep.formStep);

  // Clean up form on component destroy
  useEffect(() => {
    return async () => {
      await dispatch(clearCampaignForm());
    };
  }, []);

  const payload = {
    userGroupName: userInfo?.selectedAccessGroupName,
    userName: userInfo.user,
    campaign: {
      campaignIdentifier: {
        campaignName: campaignFormState.campaignDetails.campaignName,
        campaignDescription: campaignFormState.campaignDetails.campaignDescription,
      },
      channel: campaignFormState.campaignDetails.channelType ?? '',
      createdBy: userInfo.user,
      endTime: campaignFormState.campaignDetails?.endTime ?? '',
      frequency: campaignFormState.campaignDetails.frequency ?? '',
      lastUpdatedBy: userInfo.user,
      messageTemplateName: campaignFormState.templateDetails.messageTemplateName?.name ?? '',
      fromAddress: campaignFormState.templateDetails.fromAddress ?? '',
      segmentIdentifier: {
        segmentId: campaignFormState.segmentDetails.segmentId,
        segmentName: campaignFormState.segmentDetails.segmentName,
      },
      startTime: campaignFormState.campaignDetails?.startTime ?? '',
      timeZone: campaignFormState.campaignDetails?.timeZone?.value ?? '',
    },
  };

  const onSubmit = async () => {
    const steps = cloneDeep(campaignSteps);
    // move to next step in the wizard
    if (activeFormStep?.next === '') {
      setIsLoading(true);
      await dispatch(createCampaign(payload, sessionToken));
      setIsFormSubmitted(true);
      setIsLoading(false);
    } else {
      const currentStep = activeFormStep?.formStep;
      const index = steps.findIndex(step => step.formStep === currentStep);
      if (index > -1) {
        steps[index].state = Status.Positive;
        steps[index].completed = true;
        setActiveFormStep(steps[index + 1]);
      }
      setCampaignSteps(steps);
      setFormState(activeFormStep?.next);
      dispatch(updateCampaignFormStep(activeFormStep));
      const el = document.querySelectorAll(FORM_NAV_ELEMENTS);
      el[activeFormStep.stageLevel + 1]?.classList?.remove('disabled');
      el[activeFormStep.stageLevel + 1]?.click();
    }
  };

  useEffect(
    () => {
      (async () => {
        if (schedulingData?.status === ResponseStatus.SUCCESS) {
          // Mark all the form step complete after successful API call.
          let steps = cloneDeep(campaignSteps);
          steps[steps.length - 1].state = Status.Positive;
          steps[steps.length - 1].completed = true;
          await dispatch(updateFormSubmissionStatus(true));
          setCampaignSteps(steps);
          history.push(CAMPAIGN_LIST_PAGE);
        } else {
          await dispatch(updateFormSubmissionStatus(false));
        }
      })();
    },
    [schedulingData.status],
  );

  const onFormSectionChange = step => {
    if (step.completed) {
      setFormState(step.formStep);
      setActiveFormStep(step);
    }
    return;
  };

  const cancelButtonClick = async () => {
    //reset form steps on cancel click
    setCampaignSteps(CAMPAIGN_FORM);
    await dispatch(clearCampaignForm());
    history.push(HOME_PAGE);
  };

  return (
    <>
      <Col alignItems="left">
        <Row padding={20}>
          <Col width={'25%'}>
            <div className='campaign-step-wrapper'>
              {campaignSteps.map(step => {
                return (
                  // <SideNavItem
                  //   statusIcon={step.state}
                  //   className="campaignOption"
                  //   header={`Stage ${step.stageLevel + 1}`}
                  //   subHeader={step.label}
                  //   onSelect={() => onFormSectionChange(step)}
                  //   key={step.id}
                  // />
                  <SideNavItem
                    isSelected={activeFormStep.id == step.id}
                    className={(activeFormStep.id == step.id) ? 'camapign-items campaignOption-selected' : 'camapign-items'}
                    onClick={() => onFormSectionChange(step)}
                    key={step.id}>
                    <Row css={{ fontWeight: 500, fontSize: '1.125rem', lineHeight: 1.55556 }}>{`Stage ${step.stageLevel + 1}`}</Row>
                    <Row>
                      <StatusIndicator className={(activeFormStep.id == step.id) ? 'status-indicator status-indicator-selected' : 'status-indicator'} status={step.state} iconAltText="Done" messageText={step.label} />
                    </Row>
                  </SideNavItem>
                );
              })}
            </div>
          </Col>
          <Spacer width={30} />
          <Col data-testid="form-section" width={'60%'}>
            {formState === CampaignFormSection.CAMPAIGN && <CampaignSection />}
            {formState === CampaignFormSection.SEGMENT && (
              <CreateSegment campaignView={true} showUseSegment={true} onNext={onSubmit} />
            )}
            {formState === CampaignFormSection.TEMPLATE && <TemplateSection />}
            {formState === CampaignFormSection.SCHEDULE && <ScheduleSection />}
            {formState === CampaignFormSection.REVIEW && <ReviewAndLaunch />}
          </Col>
        </Row>
      </Col>
      <Col width={'98%'}>
        {!isLoading &&
          isFormSubmitted && (
            <MessageBanner
              data-testid="message-banner"
              type={apiStatus ? apiStatus : ResponseStatus.ERROR}
            >
              {apiStatus ? Message[apiStatus] : Message[ResponseStatus.ERROR]}
            </MessageBanner>
          )}
      </Col>
      <Spacer height={30} />
      <Row display="flex" style={{ justifyContent: 'center', alignItems: 'center' }}>
        {formState === CampaignFormSection.SEGMENT &&
          schedulingDetail.segmentType !== SegmentType.EXISTING ? (
          <></>
        ) : (
          <>
            <View>
              <ButtonWithLoader
                data-testid="campaign-save-continue-btn"
                isLoading={isLoading}
                isPrimary={true}
                isDisabled={!isFormSectionValid || isFormSubmitted}
                onClickHandler={onSubmit}
              >
                {formState !== CampaignFormSection.REVIEW ? (
                  <FormattedMessage
                    id="app.campaign.label.saveAndContinue"
                    defaultMessage="Save and continue"
                  />
                ) : (
                  <FormattedMessage
                    id="app.campaign.label.submitAndLaunch"
                    defaultMessage="Submit and Launch"
                  />
                )}
              </ButtonWithLoader>
            </View>
            <Spacer width={25} />
            <View>
              <Button
                data-testid="campaign-cancel-btn"
                onClick={() => cancelButtonClick()}
                tertiary={true}
              >
                <FormattedMessage id="app.button.cancel" defaultMessage="Cancel" />
              </Button>
            </View>
          </>
        )}
      </Row>
      <Spacer height={30} />
    </>
  );
};

export default SchedulingContainer;
